import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'

import HeaderAction from './Action'

export default {
	methods: {
		formatDate,
		formatDateTime
	},

	components: {
		HeaderAction
	}
}
